import styled from "styled-components";
import { px2rem } from "../../../../../utils/css";
export const SingleCardWrap = styled.a `
	display: flex;
	background-color: #fff;
	border-radius: 6px;
`;
export const Dec = styled.div `
	width: ${px2rem(231)};
	padding: 6px 6px 6px 9px;
	display: flex;
	flex-direction: column;
`;
export const BottomDec = styled.div `
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	flex: 1;
`;
